import styled from 'styled-components'

import { helpers } from 'styles'

export const Title = styled.h3`
	margin: 0;
	font-size: ${helpers.font.size.large};
	font-weight: 700;
`
